import { Box, Text, useColorModeValue as mode } from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";

const SearchResultRow = ({
  jobId,
  number,
  date,
  time,
  customer,
  console,
  serial,
  jobName,
  complete,
  pickedUp,
  irreparable,
  isBooking,
  isCancelled,
  index,
  header,
  selected,
  onSelect,
  onDouble,
}) => {
  const rowBg = selected
    ? mode("blue.100", "blue.700")
    : index % 2 === 0
    ? mode("white", "gray.800")
    : mode("gray.100", "gray.700");

  const commonBoxProps = {
    borderRight: "1px solid",
    borderColor: mode("gray.200", "gray.600"),
    //overflow: { base: "inherit", md: "auto" },
  };

  return (
    <Box
      display='grid'
      gridTemplateColumns='60px 70px 80px 1fr 1fr 1.2fr 1.2fr 30px 30px 30px 30px'
      bg={rowBg}
      alignItems='stretch'
      borderBottom='1px solid'
      borderColor={mode("gray.200", "gray.600")}
      minH='38px'
      fontStyle={isBooking ? "italic" : "normal"}
      textDecoration={isBooking && isCancelled ? "line-through" : "none"}
      color={isBooking ? mode("purple.600", "purple.300") : "inherit"}
      mx='-4'
      onClick={() => onSelect && onSelect(index)}
      onDoubleClick={() => onDouble && onDouble(index)}
    >
      <Box
        {...commonBoxProps}
        as={header ? undefined : ReactLink}
        to={header ? undefined : `/job/${number}`}
        cursor={header ? "default" : "pointer"}
        position='sticky'
        left={0}
        zIndex={1}
        bg={rowBg}
      >
        <Text
          textAlign='left'
          fontWeight={header ? "bold" : "normal"}
          p={1}
          textDecoration={header ? "none" : "underline"}
          textUnderlineOffset='2px'
        >
          {number}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {date}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {time}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {customer}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {console}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {serial}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {jobName}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {header ? "B" : isBooking ? "✔" : ""}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {header ? "C" : complete ? "✔" : ""}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {header ? "P" : pickedUp ? "✔" : ""}
        </Text>
      </Box>
      <Box {...commonBoxProps}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {header ? "I" : irreparable ? "✔" : ""}
        </Text>
      </Box>
    </Box>
  );
};
export default SearchResultRow;
